import React from 'react';

function Footer() {

    return(
        <footer>
            <div className="wrapper">
                <p>Created by Camila <a href="https://github.com/camiaparicio/projectThree">at Juno College</a></p>
            </div>
        </footer>
    )
}

export default Footer;